import React from 'react'
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';

/**
 * Renders a power button, redirecting to /logout route.
 * uses icon from: https://fontawesome.com/v5.15/icons/power-off
*/
const PowerButton = () => {
    return (
        <Nav.Item className="">
            <Nav.Link as={Link} className="power-btn" to="/logout"><i class="fa fa-power-off"></i></Nav.Link>
        </Nav.Item>
    )
}

export default PowerButton